import React from 'react'
import { createRoot } from 'react-dom/client'
import '@/styles/globals.css'
import { ThemeProvider } from '@/components/theme-provider.tsx'
import * as Sentry from '@sentry/react'
import { Toaster } from '@/components/ui/sonner.tsx'
import AppContainer from '@/AppContainer.tsx'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'

// @ts-ignore
i18n.use(HttpApi)
	.use(initReactI18next)
	.init({
		fallbackLng: 'en-US',
		load: 'currentOnly',
		supportedLngs: ['de-DE', 'en-US', 'es-ES', 'fa-IR', 'fr-FR', 'it-IT', 'ar-SA', 'ru-RU', 'tr-TR', 'uk-UA'],
		interpolation: {
			escapeValue: false,
		},
		backend: {
			loadPath: '/locales/{{lng}}.json',
		},
	})

Sentry.init({
	enabled: import.meta.env.VITE_ENVIRONMENT === 'production' && window.location.port !== '5173',
	environment: import.meta.env.VITE_ENVIRONMENT,
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [
		Sentry.replayIntegration(),
		Sentry.captureConsoleIntegration({
			levels: ['error', 'warning', 'debug'],
		}),
		Sentry.linkedErrorsIntegration(),
		Sentry.browserTracingIntegration(),
		// Sentry.httpClientIntegration({
		// 	failedRequestStatusCodes: [[404, 599]],
		// }),
	],
	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

createRoot(document.getElementById('root') as HTMLElement, {
	// Callback called when an error is thrown and not caught by an ErrorBoundary.
	onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
		console.warn('Uncaught error', error, errorInfo.componentStack)
	}),
	// Callback called when React catches an error in an ErrorBoundary.
	onCaughtError: Sentry.reactErrorHandler(),
	// Callback called when React automatically recovers from errors.
	onRecoverableError: Sentry.reactErrorHandler(),
}).render(
	<React.StrictMode>
		<ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
			<AppContainer />
			<Toaster />
		</ThemeProvider>
	</React.StrictMode>,
)
